/**
 * Aturan render sub-baris "Tingkat n" pada tab Monitoring Program.
 *
 * Bentuk data backend (diverifikasi di development-second, [MAI-1296]):
 * - Endpoint list distributor: `level` = null untuk program satu tingkat, dan
 *   "Tingkat n" untuk program bertingkat — termasuk saat progresnya masih 0%.
 * - Endpoint detail per distributor: `current_level` = "Tingkat 1" untuk program satu
 *   tingkat MAUPUN bertingkat, jadi field itu tidak bisa dipakai sebagai pembeda.
 * - Pembeda yang andal hanya `detail.program_target_reward.target_term.level_enum`.
 *
 * Modal "Hadiah Didapatkan Distributor" TIDAK memakai aturan ini: isinya dipecah per
 * tingkat, jadi nama tingkat justru yang membedakan antar blok.
 */
const SINGLE_LEVEL_ENUM = 'LEVEL_1';

/**
 * `true` hanya kalau program terbukti satu tingkat. Nilai tak dikenal/absen dianggap
 * bertingkat supaya label tidak pernah hilang gara-gara detail program belum dimuat —
 * itu regresi [MAI-1296].
 */
export function isSingleLevelProgram(levelEnum: string | null | undefined): boolean {
  return (levelEnum?.trim().toUpperCase() ?? '') === SINGLE_LEVEL_ENUM;
}

/**
 * Satu-satunya aturan render label tingkat — dipakai kolom Progres dan kartu ringkasan
 * modal supaya keduanya tidak bisa berbeda pendapat. [AC-02 MAI-1033] program satu
 * target tidak menampilkan baris tingkatan.
 */
export function showLevelLabel(level: string | null | undefined, isSingleLevel = false): boolean {
  return !!level?.trim() && !isSingleLevel;
}
